class TestimonialSlideMobile extends HTMLElement {
	constructor() {
		super();
		(function () {
			'use strict';
			const breakpoint = window.matchMedia('(min-width:989px)');
			let mySwiper;

			const breakpointChecker = function () {
				if (breakpoint.matches === true) {
					if (mySwiper !== undefined) mySwiper.destroy(true, true);
					return;
				} else if (breakpoint.matches === false) {
					return enableSwiper();
				}

			};

			const enableSwiper = function () {

				mySwiper = new Swiper('.js-feature-testimonials', {

					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
					loop: true,
					autoHeight: false,
					allowTouchMove: true,
					slidesPerView: 1.2,
					spaceBetween: 15,
					breakpoints: {
						320: {
							slidesPerView: 1.2,
							spaceBetween: 15,
						},
						540: {
							slidesPerView: 2.2,
							spaceBetween: 15,
						}
					}

				});

			};
			breakpoint.addListener(breakpointChecker);

			breakpointChecker();

		})();
	}
}
customElements.define("testimonial-slide-mobile", TestimonialSlideMobile);
